import { Box, Button, Collapse, List, ListItem, makeStyles, Typography } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useState } from 'react';
import classNames from 'classnames';
import { SortingCenter, UserRole } from 'types';
import { colors } from 'theme';
import { SortingCenterChildren } from './SortingCenterChildren';

const useStyles = makeStyles(theme => ({
  sortingCenterButton: {
    padding: '1.5em 4em',
    border: '1px solid #E9EDEF',
    fontWeight: 600,
    textAlign: 'left',
    marginBottom: '2em',
    minHeight: '7em',
  },
  buttonSelected: {
    backgroundColor: colors.greyLightest,
  },
  disabled: {
    color: colors.greyBlue,
  },
  primary: {
    color: theme.palette.primary.main,
  },
  sortingCenterName: {
    fontWeight: 600,
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
  },
  containerListTree: {
    width: '1em',
    minHeight: '7em',
  },
  listTreePartOne: {
    width: '100%',
    height: '50%',
    borderLeft: '1px solid #E9EDEF',
    borderBottom: '1px solid #E9EDEF',
  },
  listTreePartTwo: {
    width: '100%',
    height: '50%',
    borderLeft: '1px solid #E9EDEF',
  },
  arrowCollapse: {
    color: theme.palette.primary.main,
  },
}));

export interface SortingCenterChildrenListProps {
  isAdmin: boolean;
  parentSortingCenter: SortingCenter;
  selectSortingCenter: (sortingCenter: SortingCenter) => void;
  childrenSortingCentersRoles?: { [sortingCenterId: string]: string };
}

export const SortingCenterChildrenList: React.FC<SortingCenterChildrenListProps> = ({
  isAdmin,
  parentSortingCenter,
  selectSortingCenter,
  childrenSortingCentersRoles,
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  parentSortingCenter?.childrenSortingCenter
    ?.sort((a, b) => {
      return a.code.localeCompare(b.code);
    })
    .reverse();

  return (
    <>
      <Button
        className={classNames(classes.sortingCenterButton, { [classes.buttonSelected]: isOpen })}
        onClick={() => setIsOpen(!isOpen)}
        variant="outlined"
        fullWidth
        key={parentSortingCenter['@id']}
        startIcon={
          isOpen ? <ExpandLess className={classes.arrowCollapse} /> : <ExpandMore className={classes.arrowCollapse} />
        }
      >
        <Box flexDirection="column" flexGrow={1}>
          <Typography
            component="p"
            className={classNames(classes.sortingCenterName, {
              [classes.disabled]: !parentSortingCenter.isActive,
            })}
          >
            {parentSortingCenter.name} -{' '}
            <span
              className={classNames({
                [classes.primary]: parentSortingCenter.isActive,
                [classes.disabled]: !parentSortingCenter.isActive,
              })}
            >
              {parentSortingCenter.code}
            </span>
          </Typography>
        </Box>
      </Button>
      <Collapse timeout="auto" unmountOnExit collapsedHeight={'auto'} in={isOpen}>
        <List>
          {parentSortingCenter?.childrenSortingCenter?.map((childSortingCenter, index, childSortingCenterArray) => {
            return (
              <div className={classes.flex}>
                <div className={classes.containerListTree}>
                  <div className={classes.listTreePartOne}></div>
                  {index < childSortingCenterArray.length - 1 && <div className={classes.listTreePartTwo}></div>}
                </div>
                <ListItem key={`${childSortingCenter['@id']}_${index}`}>
                  <SortingCenterChildren
                    sortingCenter={childSortingCenter}
                    selectSortingCenter={selectSortingCenter}
                    userRole={
                      isAdmin ? UserRole.ROLE_ADMIN : childrenSortingCentersRoles?.[childSortingCenter['@id']] ?? ''
                    }
                  />
                </ListItem>
              </div>
            );
          })}
        </List>
      </Collapse>
    </>
  );
};
